import { render, staticRenderFns } from "./SmallCard.vue?vue&type=template&id=6e8e0a6a&scoped=true&"
import script from "./SmallCard.vue?vue&type=script&lang=js&"
export * from "./SmallCard.vue?vue&type=script&lang=js&"
import style0 from "./SmallCard.vue?vue&type=style&index=0&id=6e8e0a6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8e0a6a",
  null
  
)

export default component.exports